<template>
    <form @submit.prevent="send()">
        <Fieldset legend="General">
            <p>This questionnaire provides the information your dentist needs for your dental treatment and oral health care.</p>

            <Field class="mt-5" label="Title">
                <Select :options="['Mr', 'Mrs', 'Miss', 'Ms', 'Dr', 'Prof']" v-model="attributes.general.title" />
            </Field>

            <Field label="First Name">
                <Input v-model="attributes.general.first_name" />
            </Field>

            <Field label="Last Name">
                <Input v-model="attributes.general.last_name" />
            </Field>

            <Field label="Address">
                <Textarea rows="4" v-model="attributes.general.address" />
            </Field>

            <Field label="Email">
                <Input type="email" v-model="attributes.general.email" />
            </Field>

            <Field label="Phone">
                <Input type="tel" v-model="attributes.general.phone" />
            </Field>

            <Field label="Date of Birth">
                <Input placeholder="dd/mm/yyyy" type="date" v-model="attributes.general.birth" />
            </Field>

            <Field label="Occupation">
                <Input v-model="attributes.general.occupation" />
            </Field>
        </Fieldset>

        <Fieldset class="mt-8" legend="Guardian">
            <p>If you are under 16, please give name and address of your parent/guardian:</p>

            <Field class="mt-5" label="Guardian's First Name">
                <Input v-model="attributes.guardian.first_name" />
            </Field>

            <Field label="Guardian's Last Name">
                <Input v-model="attributes.guardian.last_name" />
            </Field>

            <Field label="Guardian's Address">
                <Textarea rows="4" v-model="attributes.guardian.address" />
            </Field>
        </Fieldset>

        <Fieldset class="mt-8" legend="History & Preferences">
            <Field label="Your Doctor/GP's Name">
                <Input v-model="attributes.history.doctor" />
            </Field>

            <Checkbox class="mt-6" label="I have dental insurance cover." v-model="attributes.history.insurance" />
            <Checkbox label="I smoke." v-model="attributes.history.smoke" />

            <Field label="Your Treatment Preference">
                <Select :options="[
                    'Amalgam fillings (Silver)',
                    'Composite fillings (white, non-metal) if suitable',
                    'No preference, guided by dentist',
                    'I wish to discuss with the dentist',
                ]" v-model="attributes.preferences.treatment" />
            </Field>

            <p class="mt-10">Although rare, accidental injury to staff can occur during handling of used instruments. If this happens during the course of your treatment, our practice requires both patient and staff member to undertake a blood test. Do you agree to a confidential blood test?</p>

            <Field label="Confidential Blood Test">
                <Select :options="[
                    'Yes',
                    'No',
                    'I wish to discuss with the dentist',
                ]" v-model="attributes.preferences.blood_test" />
            </Field>

            <p class="mt-10">In order to provide the best and safest dental treatment, your dentist needs to know of any medical problems which may affect your treatment. Have you ever had any of the following?</p>

            <Field label="Cardiovascular">
                <Checkbox label="I had 'Heart Murmer'." v-model="attributes.history.cardiovascular.heart_murmer" />
                <Checkbox label="I had 'Rheumatic Fever'." v-model="attributes.history.cardiovascular.rheumatic_fever" />
                <Checkbox label="I had 'Open Heart Surgery'." v-model="attributes.history.cardiovascular.open_heart_surgery" />
                <Checkbox label="I had 'High Blood Pressure'." v-model="attributes.history.cardiovascular.high_blood_pressure" />
                <Checkbox label="I had 'Stroke'." v-model="attributes.history.cardiovascular.stroke" />
            </Field>

            <Field label="Respiratory">
                <Checkbox label="I had 'Asthma'." v-model="attributes.history.respiratory.asthma" />
                <Checkbox label="I had 'Chest & Lung Disease'." v-model="attributes.history.respiratory.chest_lung_disease" />
                <Checkbox label="I had 'Sinus/Hay Feaver'." v-model="attributes.history.respiratory.sinus_hay_feaver" />
            </Field>

            <Field label="Other Medical Problems">
                <Checkbox label="I had 'Epilepsy'." v-model="attributes.history.other.epilepsy" />
                <Checkbox label="I had 'Diabetes'." v-model="attributes.history.other.diabetes" />
                <Checkbox label="I had 'Kidney Problems'." v-model="attributes.history.other.kidney" />
                <Checkbox label="I had 'Gastric Problems'." v-model="attributes.history.other.gastric" />
                <Checkbox label="I had 'Depressive Illness'." v-model="attributes.history.other.depressive_illness" />
                <Checkbox label="I had 'Radiotherapy'." v-model="attributes.history.other.radiotherapy" />
            </Field>

            <Field label="Medications">
                <Textarea placeholder="Please, list if you are taking any tablets, medicines, pills or drugs..." rows="4" v-model="attributes.history.medications" />
            </Field>

            <Field label="Allergies">
                <Textarea placeholder="Please, list if you ever had any allergies to medicines, or other substances (such as Latex)..." rows="4" v-model="attributes.history.allergies" />
            </Field>

            <Checkbox class="mt-6" label="I have an artificial or prosthetic joint." v-model="attributes.history.joint" />
            <Checkbox label="I experienced excessive bleeding or bruising from dental treatment (or at any other time)." v-model="attributes.history.bleeding" />

            <Field label="Virus Contact">
                <Checkbox label="I had contact with 'HIV Virus'." v-model="attributes.history.virus.hiv" />
                <Checkbox label="I had contact with 'Hepatitis B Virus'." v-model="attributes.history.virus.hepatitis_b" />
                <Checkbox label="I had contact with 'Hepatitis C Virus'." v-model="attributes.history.virus.hepatitis_c" />
            </Field>

            <Field label="Pregnancy">
                <Input placeholder="If you are pregnant, how many weeks?" v-model="attributes.history.pregnant" />
            </Field>

            <Checkbox class="mt-6" label="There are other health matters I need to talk to the dentist about." v-model="attributes.history.extra" />
        </Fieldset>

        <p class="mt-10">By the act of submitting this form, I confirm that the information supplied above is true and correct to the best of my knowledge.</p>

        <div class="text-center">
            <button :class="{ 'bg-gray cursor-not-allowed': sending }" class="appearance-none bg-green font-bold inline-block mt-5 px-4 py-3 rounded shadow-lg text-center text-sm text-white md:w-auto w-full" :disabled="sending" type="submit">{{ sending ? 'Registering...' : 'Register'}}</button>
        </div>

        <div class="mt-10" v-if="message">
            <div class="bg-green-500 text-white font-bold rounded-t px-4 py-2">
                Thank You!
            </div>
            <div class="border border-t-0 border-green-400 rounded-b bg-green-100 px-4 py-3 text-green-700">
                {{ message }}
            </div>
        </div>

        <div class="mt-10" v-if="exception">
            <div class="bg-red-500 text-white font-bold rounded-t px-4 py-2">
                {{ exception.message }}
            </div>
            <div class="border border-t-0 border-red-400 rounded-b bg-red-100 px-4 py-3 text-red-700">
                <ul class="list-disc px-5">
                    <li class="my-1" v-for="error in exception.errors">{{ error.join(' ') }}</li>
                </ul>
            </div>
        </div>
    </form>
</template>

<script>
    import axios from 'axios';

    import Checkbox from '../components/Checkbox';
    import Field from '../components/Field';
    import Fieldset from '../components/Fieldset';
    import Input from '../components/Input';
    import Select from '../components/Select';
    import Textarea from '../components/Textarea';

    export default {
        components: {
            Checkbox,
            Field,
            Fieldset,
            Input,
            Select,
            Textarea,
        },

        data() {
            return {
                attributes: {
                    general: {
                        address: null,
                        birth: null,
                        email: null,
                        first_name: null,
                        last_name: null,
                        occupation: null,
                        phone: null,
                        title: null,
                    },

                    guardian: {
                        address: null,
                        first_name: null,
                        last_name: null,
                    },

                    history: {
                        allergies: null,
                        bleeding: null,
                        doctor: null,
                        extra: null,
                        insurance: null,
                        joint: null,
                        medications: null,
                        pregnant: null,
                        smoke: null,

                        cardiovascular: {
                            heart_murmer: null,
                            high_blood_pressure: null,
                            open_heart_surgery: null,
                            rheumatic_fever: null,
                            stroke: null,
                        },

                        other: {
                            diabetes: null,
                            depressive_illness: null,
                            epilepsy: null,
                            gastric: null,
                            kidney: null,
                            radiotherapy: null,
                        },

                        respiratory: {
                            asthma: null,
                            chest_lung_disease: null,
                            sinus_hay_feaver: null,
                        },

                        virus: {
                            hepatitis_b: null,
                            hepatitis_c: null,
                            hiv: null,
                        }
                    },

                    preferences: {
                        blood_test: null,
                        treatment: null,
                    }
                },

                exception: null,
                message: null,
                sending: null,
            };
        },

        methods: {
            reset() {
                const data = this.$options.data();

                this.attributes = data.attributes;
            },

            send() {
                if (this.sending) {
                    return;
                }

                this.exception = null;
                this.message = null;
                this.sending = true;

                axios.post('/api/registration', {
                    attributes: this.attributes
                }).then(response => {
                    this.message = response.data.message;

                    this.reset();
                }).catch(exception => {
                    this.exception = exception.response.data;
                }).finally(() => {
                    this.sending = false;
                });
            }
        }
    };
</script>
